import PropTypes from 'prop-types';

import List from '@mui/material/List';
import { styled } from '@mui/material/styles';

import { NumberedListItem } from './NumberedListItem';

const StyledList = styled(List)({
  padding: 0
});

export const NumberedList = ({ listItems }) => (
  <StyledList>
    {listItems.map((item, index) => (
      <NumberedListItem
        key={`item-value-${item.value}-item-subText-${item.subText}`}
        title={item.title}
        subText={item.subText}
        number={index + 1}
      />
    ))}
  </StyledList>
);

NumberedList.propTypes = {
  listItems: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    subText: PropTypes.string
  })).isRequired
};
